module.exports = __webpack_public_path__ + "img/2024-07-01a_4.219d87f0.jpg";